import { DatePicker, ConfigProvider } from "antd"; //  adicionado BELINI
import locale from 'antd/es/date-picker/locale/pt_BR'; // adicionado BELINI
import React, { useContext, useEffect, useState } from "react";
import { Button, Table, notification } from "antd";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import axios from "axios";
import { useParams } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import "antd/dist/antd.css";
import 'antd/dist/reset.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowsRotate } from '@fortawesome/free-solid-svg-icons';
import html2pdf from 'html2pdf.js'; // Salvar em pdf - BELINI

import {
  AiOutlineEdit,
  AiFillDelete,
  AiOutlineDownload,
  AiOutlineArrowLeft,
  AiFillDollarCircle,
  AiOutlineFileText,
} from "react-icons/ai";

import notes from "../../../../assets/images/notes.png";
import "moment/locale/pt-br";

const AdminPagamentosSearch = (props) => {
  const datePickerRef = null;
  const location = useLocation();
  const { maquinaInfos, clienteInfo } = location.state;

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [listCanals, setListCanals] = useState([]);
  const [loadingTable, setLoadingTable] = useState(false);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [visibleData, setVisibleData] = useState([]); // BELINI LAZY LOADING
  const [page, setPage] = useState(1); // BELINI LAZY LOADING
  const itemsPerPage = 20; // BELINI LAZY LOADING
  const [estornos, setEstornos] = useState("");
  const [estoque, setEstoque] = useState("");
  const [cash, setCash] = useState("");
  const [nome, setnome] = useState(0);
  const [descricao, setdescricao] = useState(0);
  const [idmaquina, setidmaquina] = useState(0);
  const [valpelucia, setvalpelucia] = useState(0);
  const [valorDoPulso, setvalorDoPulso] = useState(0);
  const [TotalRemoto, setTotalRemoto] = useState(0); // Credito remoto
  // const [TotalGolpe, setTotalGolpe] = useState(0); // Golpe Evitado
  const [store_id, setstore_id] = useState(0);
  const [qtdetentativas, setqtdetentativas] = useState(0); // Pelúcia
  const [pulsotentativa, setpulsotentativa] = useState(0); // Pelúcia
  const [saidapelucia, setsaidapelucia] = useState(0); // Pelúcia
  const [limitetrava, setlimitetrava] = useState(0); // Pelúcia
  const [numerodesaidas, setnumerodesaidas] = useState(0); // Pelúcia
  const [porcentpelucia, setporcentpelucia] = useState(0); // Pelúcia
  const [porcentretida, setporcentretida] = useState(0); // Pelúcia
  const [arrecadouparcial, setarrecadouparcial] = useState(0); // Adicionado BELINI
  const [arrecadoutotal, setarrecadoutotal] = useState(0); // Adicionado BELINI
  const [versaointerface, setversaointerface] = useState(""); // Adicionado BELINI
  const [total, setTotal] = useState(""); // Adicionado BELINI
  const [saidas, setSaidas] = useState(""); // Adicionado BELINI
  const [online, setOnline] = useState(""); // Adicionado BELINI
  const [pix, setPix] = useState(""); // Adicionado BELINI
  const [credito, setCredito] = useState(""); // Adicionado BELINI
  const [debito, setDebito] = useState(""); // Adicionado BELINI
  const [taxapix, setTaxaPix] = useState(""); // Adicionado BELINI
  const [taxacredito, setTaxaCredito] = useState(""); // Adicionado BELINI
  const [taxadebito, setTaxaDebito] = useState(""); // Adicionado BELINI
  const [dataMaisAntiga, setdataMaisAntiga] = useState(null); // Adicionado BELINI
  const [dataMaisRecente, setdataMaisRecente] = useState(null); // Adicionado BELINI
  const [diasEntreDatas, setdiasEntreDatas] = useState(null); // Adicionado BELINI
  const handleRefresh = () => { window.location.reload(); }; // Atualiza a página do navegador, adicionado BELINI

  const { id } = useParams();
  const { RangePicker } = DatePicker;

  const generatePdf = () => {
    const element = document.getElementById('pdf-content');
    const options = {
      margin: 0.5,
      filename: 'relatorio.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 1, // Ajuste de escala, você pode reduzir ainda mais se necessário
        useCORS: true // Garante que imagens externas sejam renderizadas corretamente
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'landscape' // Define modo paisagem (horizontal)
      }
    };

    html2pdf().from(element).set(options).toPdf().output('blob').then((blob) => {
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Relatorio.pdf';
      link.click();
      notification.success({
        message: 'Sucesso!',
        description: 'O PDF deste relatório foi baixado com sucesso!',
      });
    });
  };

  const handleDateChange = (dates, dateStrings) => {
    setDataInicio(dateStrings ? dateStrings[0] : null);
    setDataFim(dateStrings ? dateStrings[1] : null);
  };


  const getPaymentsPeriod = (id, dataInicio, dataFim) => {
    setLoadingTable(true);

    const url = `${process.env.REACT_APP_SERVIDOR}/Info-Administrador/${id}`;
    const requestBody = {}; // Enviar no corpo da requisição - BELINI

    if (dataInicio && dataFim) { // Adiciona dataInicio E dataFim se estiverem definidos - BELINI
      requestBody.dataInicio = `${dataInicio}T00:00:00.000Z`;
      requestBody.dataFim = `${dataFim}T23:59:00.000Z`;
    }

    const urlWithParams = `${url}?dataInicio=${requestBody.dataInicio}&dataFim=${requestBody.dataFim}`;
    //  console.log("URL completa  de consulta:", urlWithParams);

    //  console.log("DATA INICIO:", dataInicio);
    // console.log("DATA FIM:", dataFim);

    axios
      .post(url, requestBody, { headers: { "x-access-token": token, "content-type": "application/json", }, })
      .then((res) => {

        // console.log('Response data da requisição:', res.data);

        setLoadingTable(false);
        setTotal(res?.data?.total);
        setEstornos(res?.data?.estornos);
        setCash(res?.data?.cash); //  Adicionado BELINI
        setdataMaisAntiga(res?.data?.dataMaisAntiga); // Adicionado BELINI
        setdataMaisRecente(res?.data?.dataMaisRecente); //  Adicionado BELINI
        setdiasEntreDatas(res?.data?.diasEntreDatas); // Adicionado BELINI
        setnome(res?.data?.nome); // Adicionado BELINI
        setdescricao(res?.data?.descricao); // Adicionado BELINI
        setidmaquina(res?.data?.idmaquina); // Adicionado BELINI
        setvalpelucia(res?.data?.valpelucia); // Adicionado BELINI
        setvalorDoPulso(res?.data?.valorDoPulso); // Adicionado BELINI
        setTotalRemoto(res?.data?.TotalRemoto); // Adicionado BELINI
        // setTotalGolpe(res?.data?.TotalGolpe); // Adicionado BELINI
        setstore_id(res?.data?.store_id); // Adicionado BELINI
        setqtdetentativas(res?.data?.qtdetentativas); // Pelúcia
        setpulsotentativa(res?.data?.pulsotentativa); // Pelúcia
        setsaidapelucia(res?.data?.saidapelucia); // Pelúcia
        setlimitetrava(res?.data?.limitetrava); // Pelúcia
        setnumerodesaidas(res?.data?.numerodesaidas); // Pelúcia
        setporcentpelucia(res?.data?.porcentpelucia); // Pelúcia
        setporcentretida(res?.data?.porcentretida); // Pelúcia
        setarrecadouparcial(res?.data?.arrecadouparcial); // Adicionado BELINI
        setarrecadoutotal(res?.data?.arrecadoutotal); // Adicionado BELINI
        setversaointerface(res?.data?.versaointerface); // Adicionado BELINI
        setSaidas(res?.data?.saidas); // Adicionado BELINI
        setEstoque(res?.data?.estoque);
        setOnline(res?.data?.online);
        setPix(res?.data?.pix);
        setCredito(res?.data?.credito);
        setDebito(res?.data?.debito);
        setTaxaPix(res?.data?.taxapix);
        setTaxaCredito(res.data.taxacredito);
        setTaxaDebito(res.data.taxadebito);
        if (res.status === 200 && Array.isArray(res.data.pagamentos)) {
          setListCanals(res.data.pagamentos);
        }
      })
      .catch((err) => {
        setLoadingTable(false);
        if ([401, 403].includes(err.response.status)) {
          setNotiMessage({
            type: "error",
            message: "Sua sessão expirou, faça login novamente. 03",
          });
          setDataUser(null);
        }
      });
  };

  useEffect(() => {
    if (dataInicio === null || dataFim === null) {
      //  console.log("carregando dados da tabela (sem datas)...");
      getPaymentsPeriod(id, dataInicio, dataFim);
    }
    // eslint-disable-next-line
  }, [id, dataInicio, dataFim]);

  useEffect(() => { // BELINI LAZY LOADING
    if (listCanals.length > 0) {
      const start = 0;
      const end = itemsPerPage;
      setVisibleData(listCanals.slice(start, end));
      setPage(1);
    }
  }, [listCanals]);

  const loadMoreData = () => { // BELINI LAZY LOADING
    const nextPage = page + 1;
    const start = (nextPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    const moreData = listCanals.slice(start, end);
    if (moreData.length > 0) {
      setVisibleData(prev => [...prev, ...moreData]);
      setPage(nextPage);
    }
  };

  useEffect(() => {
    if (dataInicio !== null && dataFim !== null) {
      //  console.log("carregando dados da tabela (com datas)...");
      getPaymentsPeriod(id, dataInicio, dataFim);
    }
    //  eslint-disable-next-line
  }, [id, dataInicio, dataFim]);

  const desktopStyles = `

  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;    
  } 

  .Botoes_Superiores {
    display: flex;
    align-items: center;
    width: 100%;
    gap: 10px; 
    margin-top: 40px !important; 
    padding-top: 20px; 
  }

 .Editar_titulo {
  margin-left: 20px;
  background-color: transparent !important;
  color: rgb(250, 247, 83) !important;
  text-align: left !important;
  line-height: 1 !important;
  height: auto;
  display: flex !important;
  align-items: center !important;
  font-size: 24px;
  margin-top: -4px !important;
  flex: 0 1 auto;
  white-space: normal;
  word-break: break-word; 
  overflow: visible; 
 }
  
  .Botoes_Superiores .Botao-Grupo {
    display: flex;
    flex-grow: 1; 
    justify-content: space-between;
    margin-left: 20px;
  }
  .Botao-Editar,
  .Botao-salvar-pdf,
  .Botao-Atualizar,
  .Botao-Voltar {
    flex: 1;
    margin: 0 10px;
    font-size: 20px;
    padding: 20px;
    height: 35px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgb(61, 60, 60);
    min-width: 80px; 
    max-width: none; 
    margin-right: 27px;
  }
  .Botao-salvar-pdf,
  .Botao-Atualizar {
    min-width: 110px; 
  }
  .Botoes_Inferiores {
    display: flex;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
    margin-top: 20px;
    padding: 0 20px; 
  } 
  .Botao-Acerto,
  .Botao-Credito,
  .Botao-Relatorio {
    flex: 1;
    margin: 0 10px;
    font-size: 20px;
    padding: 20px;
    height: 35px;
    width: 100%; 
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    border: none;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid rgb(61, 60, 60);
    max-width: 400px; 
  }

  @media (max-width: 1020px) {
    .Botao-Acerto {
     max-width: 170px;
    }
    .Botao-Credito {
      max-width: 170px;
    }
    .Botao-Relatorio {
      max-width: 120px;
    }
  }

  .Botao-Voltar { background-color: rgb(163, 80, 3); color: white; }
  .Botao-Voltar:hover { background-color: rgb(243, 164, 89); }
  .Botao-Editar { background-color:rgb(163, 3, 163); color: white; }
  .Botao-Editar:hover { background-color: rgb(248, 110, 248); }
  .Botao-salvar-pdf { background-color: rgb(1, 105, 1); color: white; }
  .Botao-salvar-pdf:hover { background-color: rgb(73, 247, 73); }
  .Botao-Atualizar { background-color: rgb(4, 8, 247); color: white; }
  .Botao-Atualizar:hover { background-color: rgb(103, 105, 255); }
  .Botao-Acerto { background-color: rgb(6, 112, 250); color: white; }
  .Botao-Acerto:hover { background-color: rgb(100, 162, 243); }
  .Botao-Credito { background-color: rgb(250, 28, 120); color: white; }
  .Botao-Credito:hover { background-color: rgb(248, 129, 179); }
  .Botao-Relatorio { background-color: #e0a800; color: white; }
  .Botao-Relatorio:hover { background-color: rgb(248, 214, 112); } 

  .Campo-Picker {
  display: flex;
  color: black;
  }
  .Campo-Picker .ant-picker {
  border-radius: 10px;
  margin-right: 5px;
  background-color: #ffffff;
  border: 2px solid rgb(61, 60, 60);
  width: 100%;
  }
  .Campo-Picker .ant-picker-input > input {
  color: black !important;
  }
  .Campo-Picker .ant-picker-input input::placeholder {
  color: black !important;
  opacity: 1;
  }
  .Campo-Picker .ant-picker:hover {
  border-color: rgba(255, 255, 255, 0.2);
  }
  .Campo-Picker .ant-picker-focused {
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
  }

  .Container_pares {
    margin-top: 30px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, 1fr); 
    gap: 5px; 
    padding: 10px; 
    justify-content: center;
    padding-left: 7px;
    padding-right: 5px;
  }
  .Editar_pair {
    display: flex;
    flex-direction: column;
    justify-content: space-between; 
    height: 100%; 
    padding-left: 15px;
    padding-right: 10px;
    gap: 15px; 
  }
  .pair {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    flex: 0 1 calc(100% / 11 - 20px);
    box-sizing: border-box;
    position: relative;
    justify-content: space-between;
    border: 2px solid rgb(61, 60, 60);
  }
  .pair_text {
    background-color: rgb(190, 190, 190) !important;
    color:rgb(3, 3, 3);
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    font-weight: bold;
    text-align: center;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }

  .pair_value {
    flex: 1;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
    color: #000000;
    text-align: center;
    word-wrap: break-word;
    width: 100%;
  }
  .pair_value > span {
    word-wrap: break-word;
  }

  scrollable-content {
    max-height: 100vh;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }  
  .tableContainer {
    width: 100%; 
    margin-top: 20px;
    padding: 0 10px; 
    box-sizing: border-box; 
    overflow-x: auto; 
    overflow-y: auto; 
    white-space: nowrap; 
    padding-left: 20px;
  }
  table {
    width: auto; 
    min-width: 600px; 
    table-layout: auto; 
    border-collapse: collapse; 
    border: 1px solid rgb(61, 60, 60) !important;
  }
  th, td {
    border: 1px solid rgb(61, 60, 60) !important;
    padding: 8px;
    text-align: left;
  }
  .table-column-data,
  .table-column-tipo,
  .table-column-valor,
  #operacao {
    text-align: center;
  }
  .table-column-data,
  .table-column-tipo,
  .table-column-valor,
  #operacao {
    background-color: #f5f5f5;
  }

  .pdf-content { 
    width: '100%';
    padding: '20px;
  }
  #pdf-content {
    background: white;
    overflow: hidden;
    box-sizing: border-box;
  }
  `;

  const mobileStyles = `

  .Maquinas-page {
    background-color: black;
    color: white; 
    margin: 0; 
    padding: 0; 
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    height: 100vh;
    height: 100dvh;
    min-height: 100vh;
    min-height: 100dvh;
    width: 100vw;
    overflow: auto;     
  } 

  .Editar_titulo {
    color: rgb(250, 247, 83);
    font-size: 24px;
    flex: 0 1 auto;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 20px;
    margin: 20px 0;
    text-align: center;
    white-space: normal;
  } 

 .Botoes_Superiores,
 .Botoes_Inferiores {
  display: flex;
  flex-direction: column; /* Alinha os botões verticalmente */
  gap: 10px; /* Espaçamento entre os botões */
  padding: 0 10px; /* Reduz o padding lateral */
 }
 .Botoes_Inferiores {
      margin-top: 5px;
 }
 .Botao-Editar,
 .Botao-salvar-pdf,
 .Botao-Atualizar,
 .Botao-Voltar,
 .Botao-Acerto,
 .Botao-Credito,
 .Botao-Relatorio {
  flex: 1 1 100%; /* Ocupa 100% da largura do container */
  max-width: 100%; /* Garante que ocupe toda a largura */
  font-size: 20px; /* Tamanho da fonte */
  padding: 20px; /* Espaçamento interno */
  border-radius: 10px; /* Bordas arredondadas */
  border: 2px solid rgb(61, 60, 60); /* Borda */
  cursor: pointer; /* Cursor ao passar o mouse */
  transition: all 0.3s ease; /* Transição suave */
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 20px;
 }

  .Botao-Voltar { background-color: rgb(163, 80, 3); color: white; }
  .Botao-Editar { background-color:rgb(163, 3, 163); color: white; }
  .Botao-Editar:hover { background-color: rgb(248, 214, 112); }
  .Botao-salvar-pdf { background-color: rgb(1, 105, 1); color: white; }
  .Botao-salvar-pdf:hover { background-color: rgb(73, 247, 73); }
  .Botao-Atualizar { background-color: rgb(4, 8, 247); color: white; }
  .Botao-Atualizar:hover { background-color: rgb(103, 105, 255); }
  .Botao-Voltar:hover { background-color: rgb(250, 31, 250); }
  .Botao-Acerto { background-color: rgb(6, 112, 250); color: white; }
  .Botao-Acerto:hover { background-color:  rgb(252, 166, 86); }
  .Botao-Credito { background-color: rgb(250, 28, 120); color: white; }
  .Botao-Credito:hover { background-color: rgb(73, 247, 73); }
  .Botao-Relatorio { background-color: #e0a800; color: white; }
  .Botao-Relatorio:hover { background-color: rgb(248, 214, 112); } 

  .tableContainer {
    overflow-x: auto;
  }
  .tableContainer {
    overflow-x: auto !important;
    min-width: 600px !important;
  }  
  table {
    min-width: 600px;
    border-collapse: collapse;
    border: 1px solid rgb(61, 60, 60) !important;
  }
  th, td {
    border: 1px solid rgb(61, 60, 60) !important;
    padding: 8px;
    text-align: left;
  }   
  .tableContainer {
      overflow-x: auto;
      min-width: 600px;
  }

  .Container_pares {
    grid-template-columns: repeat(2, 1fr) !important;
    gap: 5px !important;
    display: grid;
    padding: 10px; 
  }
  .pair_text {
    background-color: rgb(190, 190, 190) !important;
    color:rgb(3, 3, 3);
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    width: 100%;
    padding-left: 10px;
    padding-right: 10px;
  }
  .pair_value {
    font-size: 14px !important;
    flex: 1;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: #000000;
    text-align: center;
    word-wrap: break-word;
    width: 100%;
  }
  .pair {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    border: 2px solid rgb(61, 60, 60);
  }   

.Campo-Picker .ant-picker {
  height: 70px;
  display: flex;
  align-items: center; 
  padding: 0 10px; 
  border-radius: 10px; 
  background-color: #ffffff; 
  border: 2px solid rgb(61, 60, 60); 
}
.Campo-Picker .ant-picker-input {
  height: 100%; 
  display: flex;
  align-items: center;
}
.Campo-Picker .ant-picker-input input {
  font-size: 16px;
  color: black; 
  height: 100%; 
}
.Campo-Picker .ant-picker-suffix {
  display: flex;
  align-items: center;
}

}

`;

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px) and (orientation: portrait)");
    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";

    const updateStyles = () => {
      styleSheet.innerText = mediaQuery.matches ? mobileStyles : desktopStyles;
    };

    updateStyles();
    mediaQuery.addListener(updateStyles);
    document.head.appendChild(styleSheet);

    return () => {
      mediaQuery.removeListener(updateStyles);
      document.head.removeChild(styleSheet);
    };
  }, []);

  const columns = [
    {
      title: "Data",
      dataIndex: "data",
      key: "data",
      className: "table-column-data",
      render: (data) => {
        // data vem ISO UTC (ex.: 2025-10-05T05:31:51.000Z)
        const d = new Date(data);
        // converte o instante UTC para “relógio” SP fixo (UTC-3)
        const sp = new Date(d.getTime() - 3 * 60 * 60 * 1000);
        const dd = String(sp.getUTCDate()).padStart(2, "0");
        const mm = String(sp.getUTCMonth() + 1).padStart(2, "0");
        const yyyy = sp.getUTCFullYear();
        const HH = String(sp.getUTCHours()).padStart(2, "0");
        const MM = String(sp.getUTCMinutes()).padStart(2, "0");
        const SS = String(sp.getUTCSeconds()).padStart(2, "0");
        return <span>{`${dd}/${mm}/${yyyy} as ${HH}:${MM}:${SS}`}</span>;
      },
      align: "center",
      onHeaderCell: () => ({ className: "table-column-data" }),
      onCell: () => ({ className: "table-column-data" }),
    },
    {
      title: "Forma de pagamento",
      dataIndex: "tipo",
      key: "tipo",
      className: "table-column-tipo",
      render: (tipo) => (
        <span>
          {tipo === "bank_transfer"
            ? "PIX"
            : tipo === "CASH"
              ? "Pgto Em Espécie"
              : tipo === "debit_card"
                ? "Cartão No Débito"
                : tipo === "credit_card"
                  ? "Cartão No Crédito"
                  : tipo === "PELÚCIA"
                    ? "Saída De Pelúcia"
                    : tipo === "Inadimplência"
                      ? "Mensalidade atrasada"
                      : tipo === "Inativo"
                        ? "Cliente Inativo"
                        : tipo === "Offline"
                          ? "Máquina Offline"
                          : tipo === "Minimo"
                            ? "Inferior Ao Mínimo"
                            : tipo === "Credito-Remoto"
                              ? "Crédito Remoto"
                              : "N/A"}
        </span>
      ),
      align: "center",
      onHeaderCell: () => ({ className: "table-column-tipo" }),
      onCell: () => ({ className: "table-column-tipo" }),
    },
    {
      title: "Valor",
      dataIndex: "valor",
      key: "valor",
      className: "table-column-valor",
      render: (valor) =>
        new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(valor),
      align: "center",
      onHeaderCell: () => ({ className: "table-column-valor" }),
      onCell: () => ({ className: "table-column-valor" }),
    },
    {
      title: "ID da Transação",
      dataIndex: "mercadoPagoId",
      key: "mercadoPagoId",
      align: "center",
      onHeaderCell: () => ({ className: "table-column-id" }),
      onCell: () => ({ className: "table-column-id" }),
    },
    {
      title: "Operação",
      dataIndex: "tipo",
      key: "operacao",
      render: (tipo, record) => {
        // ✅ NOVA REGRA: se o ID da Transação for "Crédito Por Aplicativo"
        // mostra "Remoto" em azul, ignorando o estornado
        if (record.mercadoPagoId === "Crédito Por Aplicativo") {
          return <span style={{ color: "blue" }}>Remoto</span>;
        }

        if (record.tipo === "SAIDA") {
          return <span style={{ color: "red" }}>Retirada</span>;
        } else if (record.tipo === "PELÚCIA") {
          return <span style={{ color: "orange" }}>Saiu pelúcia</span>;
        } else if (record.estornado) {
          return (
            <span style={{ color: "red" }}>
              {record.motivoEstorno || "Estornado"}
            </span>
          );
        } else if (record.tipo === "Credito-Remoto") {
          return <span style={{ color: "blue" }}>Registrado</span>;
        } else {
          return <span style={{ color: "green" }}>Recebido</span>;
        }
      },
      align: "center",
      onHeaderCell: () => ({ className: "table-column-operacao" }),
      onCell: () => ({ className: "table-column-operacao" }),
    },
  ];

  const EditarCliente = () => {
    localStorage.setItem('Textonome', nome);
    localStorage.setItem('Textodescricao', descricao);
    localStorage.setItem('Valorpelucia', valpelucia);
    // localStorage.setItem('Numerostoryid', store_id);
    localStorage.setItem('Numeromaquina', idmaquina);
    localStorage.setItem('Valorcredito', valorDoPulso);
    localStorage.setItem('TotalRemoto', TotalRemoto);
    // localStorage.setItem('TotalGolpe', TotalGolpe);
    localStorage.setItem('Valortrava', limitetrava);
    localStorage.setItem('Valortentativa', pulsotentativa);
    localStorage.setItem('Valorestoque', estoque);
    localStorage.setItem('Interfaceversao', versaointerface);
    localStorage.setItem('Totalestorno', estornos);
    localStorage.setItem('Totalcash', cash);
    localStorage.setItem('Totalgeral', total);
    localStorage.setItem('Totalsaidas', saidas);
    localStorage.setItem('TotalPix', pix);
    localStorage.setItem('TotalCredito', credito);
    localStorage.setItem('TotalDebito', debito);
    localStorage.setItem('TaxaPix', taxapix);
    localStorage.setItem('TaxaCredito', taxacredito);
    localStorage.setItem('TaxaDebito', taxadebito);
    localStorage.setItem('DataInicial', dataInicio);
    localStorage.setItem('DataFinal', dataFim);
    navigate(`/cliente-maquinas/edit-pagamento-adm/${id}`, {
      state: location.state,
    });
  };

  const onRelatorioHandler = () => {
    if (!dataInicio && !dataFim) {
      setNotiMessage({
        type: "error",
        message:
          "Selecione no calendario a direita a data de inicio e firm para gerar o relatorio para essa maquina!",
      });

    } else {
      localStorage.setItem('Textonome', nome);
      localStorage.setItem('Textodescricao', descricao);
      localStorage.setItem('Valorpelucia', valpelucia);
      // localStorage.setItem('Numerostoryid', store_id);
      localStorage.setItem('Numeromaquina', idmaquina);
      localStorage.setItem('Valorcredito', valorDoPulso);
      localStorage.setItem('TotalRemoto', TotalRemoto);
      // localStorage.setItem('TotalGolpe', TotalGolpe);
      localStorage.setItem('Valortrava', limitetrava);
      localStorage.setItem('Valortentativa', pulsotentativa);
      localStorage.setItem('Valorestoque', estoque);
      localStorage.setItem('Interfaceversao', versaointerface);
      localStorage.setItem('Totalestorno', estornos);
      localStorage.setItem('Totalcash', cash);
      localStorage.setItem('Totalgeral', total);
      localStorage.setItem('Totalsaidas', saidas);
      localStorage.setItem('TotalPix', pix);
      localStorage.setItem('TotalCredito', credito);
      localStorage.setItem('TotalDebito', debito);
      localStorage.setItem('TaxaPix', taxapix);
      localStorage.setItem('TaxaCredito', taxacredito);
      localStorage.setItem('TaxaDebito', taxadebito);
      localStorage.setItem('DataInicial', dataInicio);
      localStorage.setItem('DataFinal', dataFim);
      navigate(`/cliente-maquinas/pagamentos/relatorio-adm/${id}`, {
        state: { maquinaInfos, clienteInfo, dataInicio, dataFim },
      });
    }
  };

  return (
    <div className="Maquinas-page">
      <div className="scrollable-content">

        <div className="Botoes_Superiores mobile-stack">
          <div className="Botoes_Superiores">

            <div className="Editar_titulo">{`${nome}`}</div>

            <Button
              className="Botao-Voltar"
              onClick={() =>
                navigate(`/cliente-maquinas/${clienteInfo.id}`, {
                  state: location.state.clienteInfo,
                })
              }
            >
              <AiOutlineArrowLeft />
              <span>Voltar</span>
            </Button>

            <Button className="Botao-Editar" onClick={() => EditarCliente()}>
              <AiOutlineEdit />
              <span>Editar</span>
            </Button>

            <Button
              className="Botao-Atualizar"
              onClick={handleRefresh}
            >
              <FontAwesomeIcon icon={faArrowsRotate} />
              Atualizar
            </Button>

            <Button
              className="Botao-salvar-pdf"
              onClick={() => generatePdf()}
            >
              <AiOutlineDownload />
              <span>Salvar PDF</span>
            </Button>

          </div>
        </div>

        <div className="Botoes_Inferiores">

          <Button
            className="Botao-Credito"
            onClick={() => {
              navigate(`/cliente-maquinas/credito-remoto-adm/${maquinaInfos.id}`, {
                state: location.state,
              });
            }}
          >
            <AiFillDollarCircle />
            <span>Crédito Remoto</span>
          </Button>

          <Button
            className="Botao-Acerto"
            onClick={() => {
              navigate(`/cliente-maquinas/delete-all-pagamentos-adm/${id}`, {
                state: location.state,
              });
            }}
          >
            <AiFillDelete />
            <span>Fazer Acerto</span>
          </Button>

          <Button className="Botao-Relatorio" onClick={() => onRelatorioHandler()}>
            <AiOutlineFileText color="white" />
            <span>Relatório</span>
          </Button>

          <div className="Campo-Picker" ref={datePickerRef}>
            <ConfigProvider locale={locale}>
              <RangePicker
                placeholder={["Data Inicial", "Data Final"]}
                onChange={handleDateChange}
                value={
                  dataInicio && dataFim
                    ? [moment(dataInicio), moment(dataFim)]
                    : []
                }
                inputReadOnly
              />
            </ConfigProvider>
          </div>
        </div>

        <div id="pdf-content">
          <div className="Container_pares">

            <div className="Editar_pair"> {/* adicionado BELINI */}

              <div className="pair">
                <div className="pair_text">Pgto Dinheiro</div> {/* alterado BELINI*/}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(cash)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Pgto no Pix</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(pix)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Pgto no Débito</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(debito)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Pgto no Crédito</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(credito)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Total Pgtos Online</div> {/*. Adicionado BELINI*/}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(online)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Total de Entradas</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(total)}</div>
              </div>
            </div>

            <div className="Editar_pair"> {/* adicionado BELINI */}
              <div className="pair">
                <div className="pair_text">Total Taxas</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(taxacredito)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Taxa Pix</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(taxapix)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Taxa Débito</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(taxadebito)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Taxa Crédito</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(taxacredito)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Total de Saidas</div>  {/* alterado BELINI*/}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(saidas)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Arrecadação Parcial</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(arrecadouparcial)}</div>
              </div>
            </div>

            <div className="Editar_pair"> {/* adicionado BELINI */}
              <div className="pair">
                <div className="pair_text">Saída de Pelúcia</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(saidapelucia)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Número de Jogadas</div>
                <div className="pair_value">
                  {Intl.NumberFormat("pt-BR").format(Math.round(qtdetentativas))}
                </div>
              </div>

              <div className="pair">
                <div className="pair_text">Número de Saídas</div>
                <div className="pair_value">
                  {Intl.NumberFormat("pt-BR").format(Math.round(numerodesaidas))}
                </div>
              </div>

              <div className="pair">
                <div className="pair_text">Porcentagem de Saída</div>
                <div className="pair_value">
                  {Intl.NumberFormat("pt-BR").format(Math.round(porcentpelucia)) + '%'}
                </div>
              </div>

              <div className="pair">
                <div className="pair_text">Porcentagem de Lucro</div>
                <div className="pair_value">
                  {Intl.NumberFormat("pt-BR").format(Math.round(porcentretida)) + '%'}
                </div>
              </div>

              <div className="pair">
                <div className="pair_text">Arrecadação Total</div> {/* adicionado BELINI */}
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(arrecadoutotal)}</div>
              </div>
            </div>

            <div className="Editar_pair"> {/* adicionado BELINI */}
              <div className="pair">
                <div className="pair_text">Total Estornado</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(estornos)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Total em Estoque</div>
                <div className="pair_value">{estoque ? Number(estoque) : 0}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Limitador Saída</div>
                <div className="pair_value"> {limitetrava} </div>
              </div>

              <div className="pair">
                <div className="pair_text">Pulso por Crédito</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(valorDoPulso)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Valor da Jogada</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(pulsotentativa)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Valor da Pelúcia</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(valpelucia)}</div>
              </div>

            </div>

            <div className="Editar_pair"> {/* adicionado BELINI */}
              <div className="pair">
                <div className="pair_text">Data Inicial</div>
                <div className="pair_value"> {dataMaisAntiga} </div>
              </div>

              <div className="pair">
                <div className="pair_text">Data Final</div>
                <div className="pair_value"> {dataMaisRecente} </div>
              </div>

              <div className="pair">
                <div className="pair_text">Número Dias</div>
                <div className="pair_value"> {diasEntreDatas} </div>
              </div>

              <div className="pair">
                <div className="pair_text">Crédito Remoto</div>
                <div className="pair_value">{Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", }).format(TotalRemoto)}</div>
              </div>

              <div className="pair">
                <div className="pair_text">Campo Livre</div>
                <div className="pair_value"> 0 </div>
              </div>

              <div className="pair">
                <div className="pair_text">Campo Livre</div>
                <div className="pair_value"> 0 </div>
              </div>

            </div>

          </div>

          <div
            className="tableContainer"
            style={{ maxHeight: "500px", overflowY: "auto" }} // BELINI LAZY LOADING
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
              if (scrollTop + clientHeight >= scrollHeight - 10) {
                loadMoreData(); // BELINI LAZY LOADING
              }
            }}
          >
            <Table
              className="table"
              columns={columns}
              dataSource={visibleData} // BELINI LAZY LOADING
              pagination={false}
              loading={loadingTable}
              locale={{
                emptyText: (
                  <div>Não foram encontrados resultados para sua pesquisa.</div>
                ),
              }}
            />
          </div>

        </div>
      </div>
    </div >
  );
};

export default AdminPagamentosSearch;
